import React from 'react';
import styled from 'styled-components';

import { QUERY_DEFAULT_VALUES } from '@/constants/catalog';
import Pagination from '@/components/Pagination';
import { PostShort } from '@/typings/model';
import Link from '@/components/Link';
import PlainPostCard from '@/components/PlainPostCard';

type Props = {
  posts: Array<PostShort>;
  currentPage: number;
  onPageChange: (page: number) => void;
  totalPage: number;
};

const PostsView = ({ posts, currentPage, onPageChange, totalPage }: Props) => {
  return (
    <Component>
      <PostsWrapper>
        {posts.map((post) => (
          <Link key={post.id} to={'/blog/' + post.urlAlias}>
            <PlainPostCard post={post} />
          </Link>
        ))}
      </PostsWrapper>
      <Pagination
        className="blog-pagination"
        pageSize={QUERY_DEFAULT_VALUES.PageLimit}
        onChange={onPageChange}
        current={currentPage}
        count={totalPage}
      />
    </Component>
  );
};

export default PostsView;

const Component = styled.div`
  margin-top: 1rem;
  .blog-pagination {
    margin-top: 1.75rem;
  }
`;

const PostsWrapper = styled.div`
  display: grid;
  row-gap: 0.5625rem;
`;
